export default __webpack_public_path__ + "static/media/qlik.logo.d030ae81.png";